import atob from 'atob';
/*
 * Return the global id from an encoded string
 * @param {String} the encoded id
 * @return {Integer} the decoded id
 */
const toGlobalID = (id) => {
  if (!id) {
    return null;
  }
  return parseInt(atob(id).split(':')[1], 10);
};
export default toGlobalID;
